/**
 * Monkey patch window.fetch to make requests to https://zapier.com
 * relative to current host instead. This works around an issue
 * paginating private services requests locally.
 *
 * This function should probably only be used in the local dev
 * environment. If we change the `api/v4/implementations-meta`
 * endpoint to return relative `next` urls, we can get rid of this
 * function entirely.
 */
export default function makeZapierRequestsRelative() {
  if (typeof window !== 'undefined') {
    const realFetch = window.fetch;

    window.fetch = function (url, opts) {
      if (typeof url === 'string') {
        const newUrl = url.replace(/^https:\/\/zapier.com/, '');
        return realFetch(newUrl, opts);
      }
      return realFetch(url, opts);
    };
  }
}
